import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SimCardDownloadIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sim_card_download"}/>
}
